import { useState } from 'react';
import { Box, Grid, Typography } from "@mui/material";
import { useGetPractitionerSessionsQuery } from '../services/api';
import { Session } from '../types';
import SessionCard from './SessionCard';
import SessionDialog from './SessionDialog';

type Props = {
  guid?: string
  name?: string
  omitSession?: string;
}
export function PractitionerSessions({
  guid,
  name,
  omitSession,
}: Props) {
  if (!guid)
    return null;

  return <PractitionerSessionsInternal
    guid={guid}
    name={name}
    omitSession={omitSession}
  />;
}

const PractitionerSessionsInternal = ({
  guid,
  name,
  omitSession,
}: Props) => {
  const { data: sessions, error, isLoading } = useGetPractitionerSessionsQuery(guid);
  console.log('PractitionerSessionsInternal', { guid, sessions, error, isLoading })
  const [selectedSession, setSelectedSession] = useState<Session | undefined>()
  const filteredSessions = sessions?.filter(x => omitSession !== x.guid)
  if (!filteredSessions?.length)
    return null;

  return (
    <Grid
      item
      xs={12}
    >
      <Typography
        fontWeight={500}
      >See More Sessions with {name}</Typography>
      <br />
      <Box
        display="flex"
        flexWrap="wrap"
        justifyContent="flex-start"
      >
        {filteredSessions.map((session, index) => (
          <SessionCard
            key={session.guid}
            index={index}
            onClick={() => setSelectedSession(session)}
            session={session}
          />
        ))}
      </Box>
      <SessionDialog
        onClose={() => setSelectedSession(undefined)}
        guid={selectedSession?.guid}
      />
    </Grid>
  );
}